import type { Placement } from "tippy.js";

const DEFAULT_PLACEMENT: Placement = "top";
const DEFAULT_THEME = "text-modifiers";

export const useTippyOptions = (
  placement: Placement = DEFAULT_PLACEMENT,
  allowBubbleMenuOverflow: boolean = true,
) => ({
  duration: [200, 150] as [number, number],
  arrow: false,
  placement,
  theme: DEFAULT_THEME,
  animation: "shift-away-subtle",
  maxWidth: "none",
  popperOptions: {
    strategy: "fixed" as const,
    modifiers: [
      {
        name: "preventOverflow",
        options: {
          boundary: allowBubbleMenuOverflow
            ? "clippingParents"
            : "scrollParent",
          rootBoundary: "viewport",
          altAxis: true,
          altBoundary: true,
          tether: false,
          padding: 8,
        },
      },
    ],
  },
  interactive: true,
  interactiveBorder: 20,
  interactiveDebounce: 75,
  trigger: "manual",
  hideOnClick: false,
  delay: [100, 0] as [number, number],
});
